import {Fragment} from 'react';
import {Col, Row, Skeleton, Tabs, TabsProps} from 'antd';
import IntlMessages from 'src/domain/utility/IntlMessages';
import {useParams} from 'react-router-dom';
import CampaignInfo from '../campaign-info';
import CampaignConditions from '../campaign-conditions';
import EmailAddress from '../email-address';
import HistoryOfSentEmails from '../history-of-sent-emails';
import TestCampaigns from '../test-campaign';
import {Formik} from 'formik';
import {schema} from '../schema';
import {useIntl} from 'react-intl';
import {ICampaignPayload} from 'src/shared/services/campaigns/dto/campaign-list';
import ActionsHeader from './ActionsHeader';
import MainUtils from 'src/shared/utils/main';
import {useGetCampaign} from '../../hooks/useGetCampaign';
import {formatDate} from 'src/shared/constants/AppConst';
import {dateFormat} from 'src/shared/functions/date-format';

function CampaignTabs() {
  const {id} = useParams();
  const {messages} = useIntl();
  const {isLoading, data} = useGetCampaign(id ?? '');
  const itemTabs: TabsProps['items'] = [
    {
      key: 'info',
      label: <IntlMessages id='mailing.tabs.info' />,
      children: <CampaignInfo />,
    },
    {
      key: 'conditions-for-campaigns',
      label: <IntlMessages id='mailing.tabs.conditions' />,
      children: <CampaignConditions />,
    },
  ];

  const itemsWithId = (formik: any): TabsProps['items'] => {
    return [
      {
        key: 'email-address',
        label: <IntlMessages id='mailing.tabs.email' />,
        children: <EmailAddress />,
      },
      {
        key: 'history-of-sent-emails',
        label: <IntlMessages id='mailing.tabs.history' />,
        children: <HistoryOfSentEmails />,
      },
      {
        key: 'test-campaigns',
        label: <IntlMessages id='mailing.tabs.test' />,
        children: <TestCampaigns formik={formik} />,
      },
    ];
  };

  const handleSubmit = (values: ICampaignPayload) => {};

  return (
    <Fragment>
      <Formik
        initialValues={{
          Name: data?.Name ?? '',
          Subject: data?.Subject ?? '',
          Body: data?.Body ?? '',
          EmailAccountId: data?.EmailAccountId ?? '',
          LanguageId: data?.LanguageId ?? '',
          CustomerCreatedDateFrom: !MainUtils.isEmptyValue(
            data?.CustomerCreatedDateFrom,
          )
            ? dateFormat(data?.CustomerCreatedDateFrom ?? '')
            : '',
          CustomerCreatedDateTo: !MainUtils.isEmptyValue(
            data?.CustomerCreatedDateTo,
          )
            ? dateFormat(data?.CustomerCreatedDateTo ?? '')
            : '',
          CustomerLastActivityDateFrom: !MainUtils.isEmptyValue(
            data?.CustomerLastActivityDateFrom,
          )
            ? dateFormat(data?.CustomerLastActivityDateFrom ?? '')
            : '',
          CustomerLastActivityDateTo: !MainUtils.isEmptyValue(
            data?.CustomerLastActivityDateTo,
          )
            ? dateFormat(data?.CustomerLastActivityDateTo ?? '')
            : '',
        }}
        validationSchema={schema(messages)}
        enableReinitialize
        validateOnBlur={true}
        validateOnChange={true}
        onSubmit={(values) => handleSubmit(values)}>
        {(formik) => (
          <Row gutter={[30, 30]}>
            <Col span={24}>
              <ActionsHeader formik={formik} />
            </Col>
            <Col span={24}>
              <Skeleton active loading={isLoading}>
                <Tabs
                  items={
                    !MainUtils.isEmptyValue(id)
                      ? itemTabs.concat(itemsWithId(formik) ?? [])
                      : itemTabs
                  }
                />
              </Skeleton>
            </Col>
          </Row>
        )}
      </Formik>
    </Fragment>
  );
}

export default CampaignTabs;
